<div *ngIf="this.visible2" class="modal-popUp-content content-wrapper-main-inner-content">
  <div class="row d-flex justify-content-between" mat-dialog-title>
    <div class="d-flex align-items-center justify-content-between">
      <div class="circle me-3">
        <img class="thumbnail-image"
             [src]="getConsultantImage()"
             alt="..."/>
      </div>
      <div class="">
        <div class="mb-1">
          <h3 *ngIf="visible1"
              class="font-weight-bold">{{ type === 'edit' || visible2 ? this.consultant.consultantName : 'Create Consultant' }}</h3>
          <div class="d-flex align-items-start justify-content-between">
            <div *ngIf="visible2" class="headLabels d-flex align-items-center me-3" style="font-size: 16px">
              Consultant ID:
              <span class="mb-0 ms-1 sub-label"> {{ consultantDT?.consultantId ? consultantDT.consultantId : '--' }}
            </span>
            </div>
            <div>
              <div *ngIf="visible2 && consultantDT?.createdBy && consultantDT?.createdDate"
                   class="headLabels d-flex align-items-center"  style="font-size: 16px">
                Created by: <span class="mb-0 ms-1 sub-label">
                {{ consultantDT.createdBy['firstName'] && consultantDT.createdBy['lastName'] ? consultantDT.createdBy['firstName'] + ' ' + consultantDT.createdBy['lastName'] : '--' }}
                on {{ consultantDT.createdDate | date: 'hh:mm a dd MMM yyyy' }}
              </span>
              </div>
              <div *ngIf="visible2 && consultantDT?.updatedBy && consultantDT?.updatedDate"
                   class="headLabels d-flex align-items-center "  style="font-size: 16px">
                Updated by: <h6 class="mb-0 ms-1 sub-label">
                {{ consultantDT.updatedBy['firstName'] && consultantDT.updatedBy['lastName'] ? consultantDT.updatedBy['firstName'] + ' ' + consultantDT.updatedBy['lastName'] : '--' }}
                on {{ consultantDT.updatedDate | date: 'hh:mm a dd MMM yyyy' }}
              </h6>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="(visible2) && this.type =='edit' " class="headerCard-consultant p-2">
          <div class="d-flex align-items-center mb-2"><h6 class="headerLabels mb-0">Name:</h6><h6
            class="headerValues">
            {{
              (this.consultantDT?.firstName ?? this.firstName) + ' ' +
              (this.consultantDT?.middleName ?? (this.middleName != '' ? this.middleName : '')) + ' ' +
              (this.consultantDT?.lastName ?? (this.lastName != '' ? this.lastName : ''))
            }}
          </h6>
          </div>
          <div class="d-flex align-items-center mb-2"><h6 class="headerLabels mb-0">Title:</h6><h6
            class="headerValues">{{ this.consultantDT?.title != null ? this.consultantDT?.title : '-' }}</h6>
          </div>
          <div class="d-flex align-items-center"><h6 class="headerLabels mb-0">Experience:</h6><h6
            class="headerValues">
            {{
              (this.consultantDT?.experienceYear || this.consultantDT?.experienceMonth) ?
                (((this.consultantDT?.experienceYear != 0) ? (this.consultantDT?.experienceYear + ' yrs') : '' || '') + " "
                  + (((this.consultantDT?.experienceMonth != 0) ? (this.consultantDT?.experienceMonth + ' months') : '') || ''))
                :
                '-- '
            }}
          </h6></div>
          <div class="d-flex align-items-center"><h6 class="headerLabels mb-0">Vendor Name:</h6><h6
            class="headerValues">{{ this.consultantDT?.vendor != null ? this.consultantDT?.vendor.vendorName : '-' }}</h6>
          </div>
        </div>
      </div>
      <div class="flex-grow-1"></div>
      <div class="d-flex justify-content-end align-items-center">
        <div type="button" (click)="close()" class="cross_icon themeSecondary-bg-color">
          <a>
            <svg width="15" height="15" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.2872 1L1 17.2871" stroke="black" stroke-width="2" stroke-linecap="round"/>
              <path d="M1 1L17.2872 17.2871" stroke="black" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </a>
        </div>
      </div>
    </div>

  </div>
</div>
<div *ngIf="this.visible1" class="d-flex justify-content-between member_wrapper theme-bg-color" mat-dialog-title>
  <h3 *ngIf="visible1"
      class="font-weight-bold">{{ type === 'edit' || visible2 ? this.consultant.consultantName : 'Create Consultant' }}</h3>
  <div type="button" (click)="close()" class="cross_icon themeSecondary-bg-color">
    <a>
      <svg width="15" height="15" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.2872 1L1 17.2871" stroke="black" stroke-width="2" stroke-linecap="round"/>
        <path d="M1 1L17.2872 17.2871" stroke="black" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </a>
  </div>
</div>
<!--first dialog UI-->
<mat-dialog-content class="mat-typography m-0">
  <div *ngIf="this.visible1">
    <div *ngIf="!loading" class="col-md-12 d-flex justify-content-center">
      <form [formGroup]="consultantForm" ngNativeValidate>
        <div class="form-group">
          <div class="mb-5">
            <div *ngIf="!consultantLogo && !logoLoader" class="upload"
                 (click)="fileInput.click()"
                 (drop)="onSelectLogo($event, true)"
                 (dragover)="onDragOver($event)"
                 (dragenter)="onDragEnter($event)"
                 (dragleave)="onDragLeave($event)">
              <input #fileInput style="display: none" type="file" class="form-control-file"
                     (change)="onSelectLogo($event)" accept="image/*"/>
              <button type="button" class="btn logo_upload theme-btn-color">Upload consultant's photo
                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="ms-2">
                  <path
                    d="M5.78262 3.54564L6.75012 2.57064V11.2631C6.75012 11.4621 6.82914 11.6528 6.96979 11.7935C7.11044 11.9341 7.30121 12.0131 7.50012 12.0131C7.69903 12.0131 7.8898 11.9341 8.03045 11.7935C8.1711 11.6528 8.25012 11.4621 8.25012 11.2631V2.57064L9.21762 3.54564C9.28734 3.61593 9.37029 3.67173 9.46169 3.70981C9.55308 3.74788 9.65111 3.76749 9.75012 3.76749C9.84913 3.76749 9.94716 3.74788 10.0386 3.70981C10.1299 3.67173 10.2129 3.61593 10.2826 3.54564C10.3529 3.47592 10.4087 3.39296 10.4468 3.30157C10.4849 3.21018 10.5045 3.11215 10.5045 3.01314C10.5045 2.91413 10.4849 2.8161 10.4468 2.72471C10.4087 2.63331 10.3529 2.55036 10.2826 2.48064L8.03262 0.230638C7.9629 0.160341 7.87995 0.104546 7.78855 0.0664693C7.69716 0.0283927 7.59913 0.00878906 7.50012 0.00878906C7.40111 0.00878906 7.30308 0.0283927 7.21169 0.0664693C7.1203 0.104546 7.03734 0.160341 6.96762 0.230638L4.71762 2.48064C4.57639 2.62187 4.49705 2.81341 4.49705 3.01314C4.49705 3.21286 4.57639 3.40441 4.71762 3.54564C4.85885 3.68687 5.0504 3.76621 5.25012 3.76621C5.44985 3.76621 5.64139 3.68687 5.78262 3.54564ZM12.0001 5.26314H10.5001C10.3012 5.26314 10.1104 5.34216 9.96979 5.48281C9.82914 5.62346 9.75012 5.81423 9.75012 6.01314C9.75012 6.21205 9.82914 6.40282 9.96979 6.54347C10.1104 6.68412 10.3012 6.76314 10.5001 6.76314H12.0001C12.199 6.76314 12.3898 6.84216 12.5305 6.98281C12.6711 7.12346 12.7501 7.31423 12.7501 7.51314V12.7631C12.7501 12.9621 12.6711 13.1528 12.5305 13.2935C12.3898 13.4341 12.199 13.5131 12.0001 13.5131H3.00012C2.80121 13.5131 2.61044 13.4341 2.46979 13.2935C2.32914 13.1528 2.25012 12.9621 2.25012 12.7631V7.51314C2.25012 7.31423 2.32914 7.12346 2.46979 6.98281C2.61044 6.84216 2.80121 6.76314 3.00012 6.76314H4.50012C4.69903 6.76314 4.8898 6.68412 5.03045 6.54347C5.1711 6.40282 5.25012 6.21205 5.25012 6.01314C5.25012 5.81423 5.1711 5.62346 5.03045 5.48281C4.8898 5.34216 4.69903 5.26314 4.50012 5.26314H3.00012C2.40338 5.26314 1.83109 5.50019 1.40913 5.92215C0.987175 6.3441 0.750122 6.9164 0.750122 7.51314V12.7631C0.750122 13.3599 0.987175 13.9322 1.40913 14.3541C1.83109 14.7761 2.40338 15.0131 3.00012 15.0131H12.0001C12.5969 15.0131 13.1692 14.7761 13.5911 14.3541C14.0131 13.9322 14.2501 13.3599 14.2501 12.7631V7.51314C14.2501 6.9164 14.0131 6.3441 13.5911 5.92215C13.1692 5.50019 12.5969 5.26314 12.0001 5.26314Z"
                    fill="black"/>
                </svg>
              </button>
            </div>
            <div *ngIf="consultantLogo && !logoLoader"
                 class="logo_upload theme-btn-color d-flex justify-content-center">
              <img [src]="data?.logo ?? data.profilePicture" class="uploaded_img">
              <span (click)="delete()"><i class="fas fa-times-circle"></i></span>
            </div>
            <div *ngIf="logoLoader" disabled class="d-flex justify-content-center">
              <button class="btn btn-saveform" disabled>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </div>
          <mat-form-field appearance="outline" class="w-100 border-red">
            <mat-label>Enter name</mat-label>
            <input formControlName="firstName" type="text" matInput
                   aria-describedby="title" appNoSpecialChars>
          </mat-form-field>
          <div class="continue-btn mt-5">
            <button [disabled]="logoLoader" (click)="addCandidate()" *ngIf="!showloader"
                    class="btn btn-save theme-btn-color" type="submit">Continue
            </button>
            <div *ngIf="showloader" disabled>
              <button class="btn btn-save theme-btn-color" disabled>
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                Continue
              </button>
            </div>
          </div>

        </div>
        <div class="mt-3">
          <div *ngIf="errorMessage" class="alert alert-danger">
            {{ this.errorMessage }}
          </div>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>
<!--first dialog UI-->
<mat-dialog-content class="mat-typography m-0">
  <div *ngIf="this.visible2" class="row mt-2">
    <div *ngIf="!loading" class="create-vendor">
      <mat-tab-group class="col-md-12 d-flex justify-content-center remove-border-bottom" color="transparent"
                     mat-align-tabs="center"
                     animationDuration="600ms" #tabGroup>

        <mat-tab label="Consultant Information">
          <app-consultant-info (formUpdated)="handleFormUpdate($event)" [data]="data" (firstName)="setFirstName($event)"
                               (consultantData)="this.consultantDT = $event"></app-consultant-info>
        </mat-tab>

        <mat-tab label="Skills">
          <app-consultant-skills (formUpdated)="handleFormUpdate($event)" [data]="data"
                                 [primarySkill]="this.consultantDT?.primarySkills"
                                 [secondarySkill]="this.consultantDT?.secondarySkills"></app-consultant-skills>
        </mat-tab>

        <mat-tab label="Attachments">
          <app-consultant-documents (formUpdated)="handleFormUpdate($event)"
                                    [consultantData]="data"></app-consultant-documents>
        </mat-tab>

        <mat-tab label="Communications">
          <app-consultant-communications (formUpdated)="handleFormUpdate($event)"
                                         [consultantId]="this.consultantDT?.id"></app-consultant-communications>
        </mat-tab>

        <mat-tab label="Consultant Status">
          <app-consultant-status [consultantData]="data"></app-consultant-status>
        </mat-tab>

        <mat-tab label="Assignment">
          <app-consultant-deployed [consultantData]="data"></app-consultant-deployed>
        </mat-tab>

        <mat-tab label="Settings">
          <app-consultant-settings [consultantData]="data"
                                   (consultantImageChange)="handleConsultantImageChange($event)"></app-consultant-settings>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</mat-dialog-content>
<!--first dialog UI-->
